/* Cart drawer behaviour (moved out of sections/cart-drawer-prysm.liquid so it is cached). */
(function(){
  const ROOT = document.querySelector('.prysm-cart[data-section-id]');
  if(!ROOT) return;

  const state = {
    open: false,
    sectionId: ROOT.dataset.sectionId,
    lastOpener: null,
    networkHooksInstalled: false,
    refreshSeq: 0, 
    wishlistLoaded: false
  };

  // Flag to ensure we only track the view once per session
  let wishlistViewTracked = false;

  const upsellCache = new Map(); 
  function cacheUpsells(blockId, html){ if(blockId && typeof html === 'string') upsellCache.set(blockId, html); }
  function hydrateUpsellsFromCache(wrap){
    try{
      const key = wrap && wrap.id;
      if(!key) return false;
      const target = wrap.querySelector('[data-prysm-upsells-target]');
      if(!target) return false;
      const html = upsellCache.get(key);
      if(html){ target.innerHTML = html; return true; }
    }catch(e){}
    return false;
  }

  function formatMoneyRaw(cents) {
      let val = (cents / 100).toFixed(2);
      val = val.replace('.', ','); 
      if (val.endsWith(',00')) val = val.substring(0, val.length - 3);
      return val;
  }

  function lockScroll(){ document.documentElement.style.overflow='hidden'; }
  function unlockScroll(){ document.documentElement.style.overflow=''; }
  function qs(sel, root=ROOT){ return root.querySelector(sel); }
  function qsa(sel, root=ROOT){ return Array.from(root.querySelectorAll(sel)); }

  function executeScripts(scope){
    if(!scope) return;
    const scripts = scope.querySelectorAll('script');
    scripts.forEach(old=>{
      const s = document.createElement('script');
      Array.from(old.attributes).forEach(a=>{ if(a && a.name) s.setAttribute(a.name, a.value); });
      s.text = old.text || old.textContent || '';
      old.parentNode.replaceChild(s, old);
    });
  }

  function switchTab(tabName) {
      ROOT.dataset.activeTab = tabName;
      qsa('.prysm-tab').forEach(b => b.classList.toggle('is-active', b.dataset.target === tabName));
      if(tabName === 'wishlist') {
          // Force the wishlist to reload every time the tab is opened
          state.wishlistLoaded = false; 
          loadWishlist();

          // ==========================================
          // GTM VIEW TRACKING (Fires ONLY when Wishlist tab is activated)
          // ==========================================
          if (!wishlistViewTracked) {
            wishlistViewTracked = true;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "custom_popup_viewed",
              popup_variant: "wishlist-native-block"
            });
          }
      }
  }

function updateWishlistCount() {
      let wishlist = [];
      try { wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || []; } catch(e){}
      if (!Array.isArray(wishlist)) wishlist = [];
      wishlist = wishlist.filter(i => i && i.variantId); // Strips corrupt ghost items
      qsa('.wl-count').forEach(el => el.innerHTML = wishlist.length);
  }
// Listen for wishlist updates anywhere on the website
  window.addEventListener('wishlist:updated', function(e) {
      updateWishlistCount();
      
      // Grab the latest wishlist from the event, or fallback to local storage
      const wishlist = e.detail || JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
      syncKlaviyoWishlist(wishlist);
  });

   async function loadWishlist() {
        if(state.wishlistLoaded) return;
        const container = document.getElementById('prysm-wishlist-lines');
        const emptyState = qs('.prysm-wishlist-empty');
        const footer = document.getElementById('prysm-wishlist-footer');
        const wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
        
        updateWishlistCount();

        if(wishlist.length === 0) {
            emptyState.style.display = 'block';
            if(footer) footer.style.display = 'none';
            container.innerHTML = '';
            state.wishlistLoaded = true;
            return;
        }

        if(footer) footer.style.display = 'block'; 
        container.innerHTML = '<div style="padding:40px; text-align:center; font-size:11px; color:#888;">Loading your pieces...</div>';
        emptyState.style.display = 'none';

        // Map items to an array of concurrent promises to execute all fetches in parallel
        const promises = wishlist.slice().reverse().map(async (item) => {
            try {
                const [jsonRes, htmlRes] = await Promise.all([
                    fetch(`/products/${item.productHandle}.js`, {cache: 'force-cache'}),
                    fetch(`/products/${item.productHandle}?variant=${item.variantId}`, {cache: 'force-cache'})
                ]);
                
                const product = await jsonRes.json();
                const pageHtml = await htmlRes.text();
                const doc = new DOMParser().parseFromString(pageHtml, 'text/html');

                const variant = product.variants.find(v => v.id.toString() === item.variantId.toString());
                if(!variant) return '';

                let colorName = '';
                const colorInput = doc.querySelector('input[name="properties[Color]"]');
                if (colorInput) colorName = colorInput.value;

                let isPreorder = false;
                const qaScript = doc.querySelector(`script[id="qa-variant-info-${product.id}"]`);
                if (qaScript) {
                    try {
                        const info = JSON.parse(qaScript.textContent);
                        if (info[variant.id] && info[variant.id].isPreorder) isPreorder = true;
                    } catch(e) {}
                } else {
                    const typeInput = doc.querySelector('input[name="properties[Type]"]');
                    if (typeInput && typeInput.value === 'Pre-order') isPreorder = true;
                }

                let priceHtml = `<span class="prysm-price__current">${Shopify.currency.active} ${formatMoneyRaw(variant.price)}</span>`;
                if (variant.compare_at_price > variant.price) {
                    priceHtml = `<s class="prysm-price__compare">${Shopify.currency.active} ${formatMoneyRaw(variant.compare_at_price)}</s>` + priceHtml;
                }

                const img = variant.featured_image ? variant.featured_image.src : product.images[0];
                const colorProperty = colorName ? `<div class="prysm-line__property">Color — ${colorName}</div>` : '';
                
                let displayTitle = product.title;
                if (variant.title !== 'Default Title' && !product.title.toLowerCase().includes('ring pack')) {
                    displayTitle += ` <span style="font-weight: 400; color: #000;"> / ${variant.title}</span>`;
                }

                return `
                <li class="prysm-line" data-wl-key="${variant.id}">
                    <a href="${product.url}?variant=${variant.id}" class="prysm-line__imgwrap">
                        <img src="${img}&width=240" class="prysm-line__img" loading="lazy" width="240" height="300">
                    </a>
                    <div class="prysm-line__main">
                        <div class="prysm-line__topline">
                            <div style="display:flex; flex-direction:column; gap:2px; flex:1; min-width:0;">
                                <a href="${product.url}?variant=${variant.id}" class="prysm-line__title">${displayTitle}</a>
                                ${colorProperty}
                            </div>
                            <div class="prysm-price" style="margin-left:8px;">${priceHtml}</div>
                        </div>
                        <div class="prysm-qty-wrapper" style="justify-content:space-between; padding-top:14px; margin-top:auto;">
                            <button type="button" class="prysm-line__remove" onclick="PrysmCart.removeWishlistItem('${item.productHandle}', '${variant.id}')" style="margin-left:0;">Remove</button>
                            <button type="button" class="prysm-wishlist-add" onclick="PrysmCart.addWishlistToCart(${variant.id}, this, ${isPreorder}, '${colorName.replace(/'/g, "\\'")}')" ${!variant.available ? 'disabled' : ''}>
                                ${variant.available ? 'Add to Cart' : 'Sold Out'}
                              </button>
                        </div>
                    </div>
                </li>`;
            } catch(e) { 
                console.warn("Wishlist item parse fallback error", e); 
                return '';
            }
        });

        const htmlResults = await Promise.all(promises);
        container.innerHTML = htmlResults.join('');
        document.getElementById('prysm-wishlist-footer').style.display = 'block';
        state.wishlistLoaded = true;
    }

  function syncKlaviyoWishlist(wishlist) {
      window._learnq = window._learnq || [];
      
      const klaviyoPayload = {
          'Wishlist_Items': wishlist.map(i => i.productHandle),
          'Wishlist_Count': wishlist.length
      };

      // If the user is logged into Shopify, attach their email directly to the payload
      if (ROOT.dataset.customerEmail) {
          klaviyoPayload['$email'] = ROOT.dataset.customerEmail;
      }

      // Push the custom properties to the profile
      window._learnq.push(['identify', klaviyoPayload]);
      
      console.log("🟢 [Klaviyo Sync] Identify Payload:", klaviyoPayload);
  }

  function addWishlistToCart(variantId, btnEl, isPreorder = false, colorName = '') {
      const originalText = btnEl.innerText;
      btnEl.innerText = 'Adding...';
      btnEl.disabled = true;

      const payload = { 
          id: variantId, 
          quantity: 1, 
          properties: {
              '_Added via': 'Wishlist' 
          } 
      };

      if (isPreorder) payload.properties['Type'] = 'Pre-order';
      if (colorName) payload.properties['Color'] = colorName;

      fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
      }).then(r => r.json()).then(() => {
          
          // --- NEW UX LOGIC: Remove from wishlist after successful add ---
          let wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
          wishlist = wishlist.filter(i => i.variantId.toString() !== variantId.toString());
          localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
          document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: wishlist }));
          
          // KLAVIYO: Sync the updated list because an item was removed
          syncKlaviyoWishlist(wishlist);

          state.wishlistLoaded = false; // Forces the wishlist to re-render without this item
          // ---------------------------------------------------------------

          btnEl.innerText = originalText;
          btnEl.disabled = false;
          switchTab('bag');
          refresh();
      }).catch(e => {
          btnEl.innerText = 'Error';
          setTimeout(() => { btnEl.innerText = originalText; btnEl.disabled = false; }, 2000);
      });
  }

  function removeWishlistItem(handle, varId) {
      let wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
      wishlist = wishlist.filter(i => !(i.productHandle === handle && i.variantId.toString() === varId.toString()));
      localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: wishlist }));
      
      // KLAVIYO: Sync the updated list (reduces the count/removes the item)
      syncKlaviyoWishlist(wishlist);
      
      const itemEl = qs(`[data-wl-key="${varId}"]`);
      if(itemEl) itemEl.remove();
      
      updateWishlistCount();
      if(wishlist.length === 0) {
          qs('.prysm-wishlist-empty').style.display = 'block';
          document.getElementById('prysm-wishlist-footer').style.display = 'none';
      }
  }

  async function saveForLater(handle, variantId, itemKey) {
      // 1. Instantly write to local storage
      let wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
      const exists = wishlist.some(i => i.productHandle === handle && i.variantId.toString() === variantId.toString());
      
      if (!exists) {
          wishlist.push({ productHandle: handle, variantId: variantId.toString() });
          localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
          document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: wishlist }));
          
          // KLAVIYO: Track the specific addition event and update the profile
          if (typeof window._learnq !== 'undefined') {
              window._learnq.push(['track', 'Added to Wishlist', {
                  'ProductHandle': handle,
                  'VariantID': variantId
              }]);
          }
          syncKlaviyoWishlist(wishlist);
      }

      // 2. Clear cache flag and switch tab instantly
      state.wishlistLoaded = false; 
      switchTab('wishlist');

      // 3. Fire server network mutation requests quietly...
      fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
      })
      .then(() => refresh())
      .catch(e => console.warn('PrysmCart background save mutation error:', e));
  }

  function openDrawer(opts={}){
    ROOT.classList.add('is-open');
    ROOT.setAttribute('aria-hidden','false');
    lockScroll();
    state.open = true;
    const panel = qs('.prysm-panel');
    panel && panel.focus();

    // 1. Force the tab switch if one is explicitly requested
    if(opts.tab) {
        switchTab(opts.tab);
    }

    // 2. Always refresh the cart if requested, no matter what tab we are on
    if(opts.refresh) refresh();
    
    document.dispatchEvent(new CustomEvent('prysm:cart:open'));
  }

  function closeDrawer(){
    ROOT.classList.remove('is-open');
    ROOT.setAttribute('aria-hidden','true');
    unlockScroll();
    state.open = false;
    document.dispatchEvent(new CustomEvent('prysm:cart:close'));
  }
  function toggleDrawer(){ state.open ? closeDrawer() : openDrawer(); }

  async function refresh(){
    const mySeq = ++state.refreshSeq; 
    try{
      const url = `/cart?section_id=${state.sectionId}&_=${Date.now()}`;
      const res = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
      const html = await res.text();
      if(mySeq !== state.refreshSeq) return; 

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshRoot = doc.querySelector(`#prysm-cart-drawer-${state.sectionId}`);
      
      let freshTotal = null, freshCount = null;
      if(freshRoot){
        freshTotal = parseInt(freshRoot.dataset.cartTotal || '0', 10);
        freshCount = parseInt(freshRoot.dataset.cartCount || '0', 10);
        ROOT.dataset.cartTotal = String(freshTotal);
        ROOT.dataset.cartCount = String(freshCount);
        ROOT.classList.toggle('prysm--empty', (freshCount|0) === 0); 
      }

     const freshDyn = doc.querySelector(`#prysm-cart-drawer-${state.sectionId} [data-prysm-dynamic]`);
      const freshFixed = doc.querySelector(`#prysm-cart-drawer-${state.sectionId} [data-prysm-fixed-header]`);
      const freshSlot = doc.querySelector(`#prysm-cart-drawer-${state.sectionId} [data-prysm-summary-slot]`);
      const freshAboveSlot = doc.querySelector(`#prysm-cart-drawer-${state.sectionId} [data-prysm-above-summary-slot]`);
      
      // 1. Update Fixed Header
      if(freshFixed) qs('[data-prysm-fixed-header]').replaceWith(freshFixed);

      // 2. Update Cart Items (THIS FIXES QUANTITIES & DELETES!)
      if(freshDyn){
        qs('[data-prysm-dynamic]').replaceWith(freshDyn);
        executeScripts(freshDyn);
        switchTab(ROOT.dataset.activeTab || 'bag');
      }

// 3. Update Upsells (RESPECTS SESSION STATE ON QUANTITY CHANGE)
      if(freshAboveSlot){
        const currentAbove = qs('[data-prysm-above-summary-slot]');
        const newStatic = freshAboveSlot.querySelector('.prysm-upsells-static');
        if (newStatic && sessionStorage.getItem('prysm_upsell_collapsed') === 'true') {
           newStatic.classList.add('is-collapsed');
        }
        currentAbove.replaceWith(freshAboveSlot);
        executeScripts(freshAboveSlot);
      }

      // 4. Update Summary
      if(freshSlot){
        qs('[data-prysm-summary-slot]').replaceWith(freshSlot);
        executeScripts(freshSlot);
      }


      wireDynamicHandlers();
      updateFreeship(freshTotal); 
      renderUpsells();
      measureSummaryHeight();
      restoreDiscountUIAndCheckoutHref();

    }catch(e){ console.warn('PrysmCart refresh failed', e); }
  }

 function updateFreeship(totalOverrideCents){
    const wrap = qs('[data-prysm-freeship]');
    if(!wrap) return;

    const iso = (ROOT.dataset.country || '').toUpperCase();
    const parentContainer = wrap.parentElement;
    
    // Thresholds come only from snippets/ASRJ-shipping-and-returns-main-script.liquid.
    let thresholdNum = 0;
    let thresholdLabel = '';
    if (window.ShippingGlobalData) {
      const data = window.ShippingGlobalData.getForCountry(iso);
      if (data && data.threshold) {
        // Inputs look like "CHF 280", "£240", "€200", "2000 DKK"
        const num = parseFloat(data.threshold.replace(/[^\d.]/g, ''));
        if (!isNaN(num)) {
          thresholdNum = num;
          thresholdLabel = data.threshold;
        }
      }
    }

    // Hide if no threshold applies
    if (thresholdNum <= 0) {
      if(parentContainer) parentContainer.style.display = 'none';
      return; 
    } else {
      if(parentContainer) parentContainer.style.display = 'block';
    }

    const totalCents = Number.isFinite(totalOverrideCents)
      ? Math.max(0, totalOverrideCents|0)
      : parseInt(ROOT.dataset.cartTotal || '0', 10);

    const remainingCents = Math.max(0, Math.round(thresholdNum*100) - totalCents);

    const txtTemplate = wrap.dataset.text || "Shipping is on us for orders above {threshold}";
    const reachedTemplate = wrap.dataset.reachedText || "Free shipping unlocked";
    
    const fmtRemaining = (ROOT.dataset.currency || '') + ' ' + formatMoneyRaw(remainingCents);
    const fmtThreshold = thresholdLabel;

    const finalText = (remainingCents <= 0)
      ? reachedTemplate.replace(/\{threshold\}/g, fmtThreshold)
      : txtTemplate.replace(/\{remaining\}/g, fmtRemaining).replace(/\{threshold\}/g, fmtThreshold);

    const txtEl = wrap.querySelector('[data-prysm-freeship-text]');
    if(txtEl) txtEl.innerHTML = finalText;

    const pct = thresholdNum > 0 ? Math.min(100, (totalCents/(thresholdNum*100))*100) : 0;
    const fill = wrap.querySelector('[data-prysm-freeship-fill]');
    if(fill) fill.style.width = `${pct}%`;
  }

  function changeQuantityByKey(key, newQty){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: Math.max(0, newQty) })
    }).then(r=>r.json()).then(json=>{
      refresh();
      return json;
    }).catch(e=>console.warn('PrysmCart change error', e));
  }


    


function renderUpsells() { /* Now rendered securely in Liquid */ }
  function wireUpsellAdd() { /* Replaced by inline onclick handlers */ }

    function addUpsell(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          '_Added via': 'Cart upsell'
        }
      })
    }).then(r => r.json()).then(() => {
      openDrawer({refresh: true, tab: 'bag'});
    }).catch(e => console.warn('PrysmCart upsell add error', e));
  }


  function measureSummaryHeight(){
    const fixed = ROOT.dataset.fixed === 'true';
    const slot = qs('[data-prysm-summary-slot]');
    const h = (fixed && slot) ? (slot.offsetHeight || 0) : 0;
    ROOT.style.setProperty('--prysm-summary-h', h + 'px');
  }

  async function applyDiscount(code){
    const codeToApply = code ? code : ''; 
    try { await fetch(`/discount/${encodeURIComponent(codeToApply)}?redirect=/cart`, { credentials: 'same-origin' }); } catch(e) {}

    try {
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { prysm_discount_code: codeToApply, _force_refresh: Date.now() } })
        });
    } catch(e) {}

    await new Promise(r => setTimeout(r, 350));
    await refresh();
    updateCheckoutHref(code);
  }

  function updateCheckoutHref(code){
    qsa('.prysm-checkout').forEach(a=>{
      try{
        const url = new URL(a.getAttribute('href'), location.origin);
        if(code){ url.pathname = '/checkout'; url.searchParams.set('discount', code); }
        else{ url.searchParams.delete('discount'); }
        a.setAttribute('href', url.pathname + url.search);
      }catch(e){}
    });
  }

  async function restoreDiscountUIAndCheckoutHref(){
    try{
      const cart = await fetch('/cart.js', { cache:'no-store', credentials:'same-origin' }).then(r=>r.json());
      let storedCode = cart && cart.attributes && cart.attributes.prysm_discount_code ? String(cart.attributes.prysm_discount_code).trim() : '';

      let urlCode = null;
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('discount')) {
        urlCode = urlParams.get('discount');
      } else {
        const pathMatch = window.location.pathname.match(/\/discount\/([^\/]+)/);
        if (pathMatch && pathMatch[1]) urlCode = pathMatch[1];
      }

      if(urlCode && urlCode.trim() !== storedCode){
        await applyDiscount(urlCode);
        return; 
      }
      if(storedCode) updateCheckoutHref(storedCode);
    }catch(e){}
  }

  function wireDynamicHandlers(){
    qsa('[data-prysm-qty]').forEach(wrap=>{
      const key = wrap.dataset.key;
      const input = wrap.querySelector('[data-prysm-qty-input]');
      wrap.addEventListener('click', (e)=>{
        const b = e.target.closest('[data-prysm-qty-change]');
        if(!b) return;
        const delta = parseInt(b.dataset.prysmQtyChange,10);
        const next = Math.max(0, parseInt(input.value||'0',10) + delta);
        changeQuantityByKey(key, next);
      });
    });

    if(window.Shopify && Shopify.designMode){
      qsa('.prysm-editor-note').forEach(n=>{ n.style.display = 'block'; });
    }
    updateFreeship(); 
    updateWishlistCount();
  }

  (function takeoverLegacyCartTriggers(){
    const LEGACY_TOGGLE_SELECTORS = [
      '[data-drawer-toggle="drawer-cart"]', '[aria-controls="drawer-cart"]', '[data-target="drawer-cart"]',
      'a[href="#drawer-cart"]', '.js-drawer-open-cart', '.js-cart-trigger', '[data-open-cart]', '[data-cart-trigger]'
    ].join(',');

    document.addEventListener('click', function(e){
      const t = e.target && e.target.closest && e.target.closest(LEGACY_TOGGLE_SELECTORS);
      if(!t) return;
      e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
      openDrawer({refresh:true, tab:'bag'});
    }, true);
  })();

  document.addEventListener('click', (e)=>{
    const openBtn = e.target.closest('[data-prysm-open-cart]');
    if(openBtn){ state.lastOpener = openBtn; openDrawer({tab:'bag'}); }
    
    const openWishlistBtn = e.target.closest('[data-prysm-open-wishlist]');
    if(openWishlistBtn){ e.preventDefault(); state.lastOpener = openWishlistBtn; openDrawer({tab:'wishlist'}); }
    
    if(e.target.closest('[data-prysm-close]')) closeDrawer();
  });

  ['cart:open','open-cart','theme:cart:open','product:added','ajaxProduct:added','added_to_cart','cart:added','AddedItemToCart'].forEach(ev=>{
    document.addEventListener(ev, ()=> openDrawer({refresh:true, tab:'bag'}));
    window.addEventListener(ev, ()=> openDrawer({refresh:true, tab:'bag'}));
  });

  document.addEventListener('submit', function(e){
    const form = e.target;
    if(!(form instanceof HTMLFormElement)) return;
    const action = (form.getAttribute('action')||'').toLowerCase();
    if(/\/cart\/add/.test(action)){
      if(ROOT.dataset.openOnAdd === 'true') openDrawer({refresh:false, tab:'bag'});
    }
  }, true);

  ;(function installNetworkHooks(){
    if(state.networkHooksInstalled) return;
    state.networkHooksInstalled = true;
    const _fetch = window.fetch;
    window.fetch = function(){
      try{
        const url = arguments[0];
        const isAdd = typeof url === 'string' && /\/cart\/add(\.js)?/i.test(url);
        const isMut = typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?/i.test(url);
        return _fetch.apply(this, arguments).then(async res=>{
          if(isMut){
            Promise.resolve().then(()=>{
              if(isAdd && ROOT.dataset.openOnAdd === 'true') openDrawer({refresh:true, tab:'bag'});
              else if(state.open) refresh();
            });
          }
          return res;
        });
      }catch(e){ return _fetch.apply(this, arguments); }
    };
    const _open = XMLHttpRequest.prototype.open;
    const _send = XMLHttpRequest.prototype.send;
    let _isAdd = false, _isMut = false;
    XMLHttpRequest.prototype.open = function(method, url){
      try{
        _isAdd = typeof url === 'string' && /\/cart\/add(\.js)?/i.test(url);
        _isMut = typeof url === 'string' && /\/cart\/(add|change|update)(\.js)?/i.test(url);
      }catch(e){ _isAdd=false; _isMut=false; }
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      if(_isMut){
        this.addEventListener('load', ()=>{
          if(_isAdd && ROOT.dataset.openOnAdd === 'true') openDrawer({refresh:true, tab:'bag'});
          else if(state.open) refresh();
        });
      }
      return _send.apply(this, arguments);
    };
  })();

  restoreDiscountUIAndCheckoutHref(); 
  wireDynamicHandlers();
  renderUpsells();
  measureSummaryHeight();

  // --- KLAVIYO FORM HIDE LOGIC ---
  window.hideWishlistForm = function(e) {
    e.preventDefault();
    // Target the shared wrapper since the button is outside the form
    const wrapper = e.target.closest('.prysm-wishlist-klaviyo-form');
    const form = wrapper.querySelector('form');
    const revealContainer = form.querySelector('#wishlist-form-reveal');
    const closeBtn = document.getElementById('wishlist-form-close');
    
    // Hide the inputs and the close button
    revealContainer.style.display = 'none';
    if (closeBtn) closeBtn.style.display = 'none';
    
    // Remove the required attributes so the hidden inputs don't block normal interactions
    form.querySelector('input[name="first_name"]').removeAttribute('required');
    form.querySelector('input[name="email"]').removeAttribute('required');
  };

  // --- KLAVIYO FORM SUBMISSION LOGIC ---
  window.submitWishlistKlaviyo = function(e) {
    e.preventDefault();
    const form = e.target;
    const revealContainer = form.querySelector('#wishlist-form-reveal');
    const closeBtn = document.getElementById('wishlist-form-close');
    const btn = form.querySelector('button[type="submit"]');

    // STEP 1: REVEAL THE FORM ON FIRST CLICK
    if (revealContainer.style.display === 'none') {
        revealContainer.style.display = 'flex';
        
        // Show the rotated ">" close button
        if (closeBtn) closeBtn.style.display = 'block';
        
        // Add HTML5 validation attributes only after it becomes visible
        form.querySelector('input[name="first_name"]').setAttribute('required', 'true');
        form.querySelector('input[name="email"]').setAttribute('required', 'true');

        // Automatically focus the first input so they can start typing immediately
        setTimeout(() => {
             form.querySelector('input[name="first_name"]').focus();
        }, 50);
        
        return; // Stop function here and wait for the second click
    }

    // STEP 2: PROCESS THE SUBMISSION ON SECOND CLICK
    const msg = form.querySelector('.prysm-wishlist-msg');
    const email = form.querySelector('input[name="email"]').value.trim();
    const firstName = form.querySelector('input[name="first_name"]').value.trim();

    if (!email) return;

    btn.innerText = 'SENDING...';
    btn.style.opacity = '0.7';

    // PUSH SUBMIT EVENT TO GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "custom_popup_submitted",
      popup_variant: "wishlist-native-block"
    });

    const wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
    const wishlistHandles = wishlist.map(i => i.productHandle);

    const KLAVIYO_LIST_ID = form.querySelector('input[name="g"]').value;

    const formData = new URLSearchParams();
    formData.append('g', KLAVIYO_LIST_ID);
    formData.append('email', email);
    formData.append('$first_name', firstName);
    formData.append('$source', 'Wishlist Drawer'); 
    
    formData.append('$fields', 'Popup_Has_Discount, Popup_Flow_Trigger, Wishlist_Items, Wishlist_Count');
    
    formData.append('Popup_Has_Discount', 'No'); 
    formData.append('Popup_Flow_Trigger', 'Wishlist');
    
    formData.append('Wishlist_Items', JSON.stringify(wishlistHandles));
    formData.append('Wishlist_Count', wishlist.length);

    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString()
    })
    .then(r => r.json())
    .then(res => {
      btn.innerText = 'SAVE & SEND WISHLIST';
      btn.style.opacity = '1';
      msg.style.display = 'block';
      msg.style.color = '#111';
      msg.innerText = 'Sent!';
      
      // Hide the form and close button again after successful submission
      revealContainer.style.display = 'none';
      if (closeBtn) closeBtn.style.display = 'none';
      form.reset();
      
      // Keep browser profile synced with Klaviyo
      if (window._learnq) {
        window._learnq.push(['identify', { 
            '$email': email, 
            '$first_name': firstName,
            'Wishlist_Items': wishlistHandles,
            'Wishlist_Count': wishlist.length
        }]);
        
        // Pass the data directly into the Event so it can trigger multiple times
        window._learnq.push(['track', 'Requested Wishlist', {
            'Wishlist_Items': wishlistHandles,
            'Wishlist_Count': wishlist.length
        }]);
      }
    })
    .catch(err => {
      btn.innerText = 'SAVE & SEND WISHLIST';
      btn.style.opacity = '1';
      msg.style.display = 'block';
      msg.style.color = '#111';
      msg.innerText = 'Sent!';
      revealContainer.style.display = 'none';
      if (closeBtn) closeBtn.style.display = 'none';
      form.reset();
    });
  };

window.PrysmCart = { 
    open: openDrawer, 
    close: closeDrawer, 
    toggle: toggleDrawer, 
    refresh: refresh, 
    _cacheUpsells: cacheUpsells,
    switchTab: switchTab,
    removeWishlistItem: removeWishlistItem,
    addWishlistToCart: addWishlistToCart,
    saveForLater: saveForLater,
    removeDiscount: function() { applyDiscount(''); },
    addUpsell: addUpsell,
    changeQty: changeQuantityByKey /* <-- Added function for the delete button */
  };
})();
